import React, { useState, useEffect } from "react";
import { getAdminOverview } from "../../api/adminOverview.api";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const Overview = ({ setTab }) => {

  const navigate = useNavigate();

  const [stats,setStats] = useState({
    total_products:0,
    total_buyers:0,
    total_sellers:0,
    monthly_rfqs:0
  });

  const [pending,setPending] = useState([]);
  const [reportModal,setReportModal] = useState(false);

  useEffect(()=>{

    getAdminOverview()
      .then(res=>{
        const data = res.data.data;

        setStats({
          total_products:data.total_products,
          total_buyers:data.total_buyers,
          total_sellers:data.total_sellers,
          monthly_rfqs:data.monthly_rfqs
        });

        setPending([
          ...(data.pending_products || []),
          ...(data.pending_users || [])
        ]);
      })
      .catch(err=>console.log(err));

  },[]);


  const handleAction = (label)=>{

    if(label==="Add Product"){
      setTab("products");
    }

    if(label==="Add Category"){
      setTab("categories");;
    }

    if(label==="Verify Users"){
      setTab("users");
    }

    if(label==="View Reports"){
      setReportModal(true);
    }

  };


  const cardStyle = {
    backgroundColor:"#ffffff",
    border:"1px solid #e5e7eb",
    borderRadius:"12px",
    boxShadow:"0 1px 3px rgba(0,0,0,0.05)",
    padding:"24px"
  };

  const metricTitle = {
    color:"#6b7280",
    fontSize:"14px",
    fontWeight:"700",
    textTransform:"uppercase"
  };

  const metricValue = {
    color:"#112347",
    fontSize:"clamp(24px, 3vw, 32px)",
    fontWeight:"800",
    marginTop:"8px"
  };

  const metricSubtext = {
    color:"#9ca3af",
    fontSize:"12px",
    fontWeight:"500",
    marginTop:"4px"
  };

  const ghostButtonStyle = {
    backgroundColor:"#f3f4f6",
    border:"1px solid #e5e7eb",
    borderRadius:"12px",
    padding:"clamp(15px, 3vw, 35px) clamp(10px, 2vw, 20px)",
    cursor:"pointer",
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
    justifyContent:"center",
    gap:"12px",
    width:"100%",
    transition:"all 0.2s"
  };


  const statsData = [
    { label:"Total Products", icon:"📦", value:stats.total_products },
    { label:"Total Buyers", icon:"👤", value:stats.total_buyers },
    { label:"Total Sellers", icon:"🏪", value:stats.total_sellers },
    { label:"Monthly RFQs", icon:"🛒", value:stats.monthly_rfqs }
  ];


  return (

    <div className="container-fluid p-0">

      {/* METRICS */}
      <div className="row g-3 g-md-4 mb-4 mb-md-5">

        {statsData.map((item,idx)=>(
          <div className="col-12 col-sm-6 col-lg-3" key={idx}>

            <div style={cardStyle}>

              <div className="d-flex justify-content-between align-items-start">

                <div>
                  <div style={metricTitle}>{item.label}</div>
                  <div style={metricValue}>{item.value}</div>
                  <div style={metricSubtext}>Dashboard Metric</div>
                </div>

                <div style={{fontSize:"22px",opacity:0.5}}>
                  {item.icon}
                </div>

              </div>

            </div>

          </div>
        ))}

      </div>


      <div className="row g-4">

        {/* PENDING APPROVALS */}
        <div className="col-12 col-lg-6">

          <div style={cardStyle}>

            <h5 className="fw-bold mb-1">Pending Approvals</h5>
            <p className="text-muted small mb-4">Items requiring admin action</p>

            {pending.length === 0 &&
              <div className="text-muted small">
                No items pending review.
              </div>
            }

            {pending.map((item,i)=>(
              <div
                key={i}
                className="d-flex flex-column flex-sm-row align-items-start align-sm-items-center justify-content-between p-3 mb-3 border rounded-3 bg-white gap-3"
                style={{borderColor:"#f3f4f6"}}
              >

                <div className="d-flex align-items-center gap-3 flex-grow-1">

                  <span className="fs-4">📦</span>

                  <div>
                    <div className="fw-bold text-dark">{item.title}</div>
                    <div className="small text-muted">{item.subtitle}</div>
                  </div>

                </div>

                <button
                  className="btn btn-sm btn-outline-dark px-4 fw-bold border-2"
                  style={{whiteSpace:"nowrap", flexShrink: 0}}
                  onClick={() => {
                    if (item.type === "USER") {
                      setTab("users");
                    } else {
                      setTab("listed");
                    }
                  }}
                >
                  Review
                </button>

              </div>
            ))}

          </div>

        </div>


        {/* QUICK ACTIONS */}
        <div className="col-12 col-lg-6">

          <div style={cardStyle}>

            <h5 className="fw-bold mb-1">Quick Actions</h5>
            <p className="text-muted small mb-4">Common administrative tasks</p>

            <div className="row g-3">

              {[
                {label:"Add Product",icon:"➕"},
                {label:"Add Category",icon:"🔳"},
                {label:"Verify Users",icon:"👤"},
                {label:"View Reports",icon:"📈"}
              ].map((action,idx)=>(
                <div className="col-6" key={idx}>

                  <div
                    style={ghostButtonStyle}
                    onClick={()=>handleAction(action.label)}
                    onMouseOver={(e)=>e.currentTarget.style.backgroundColor="#e5e7eb"}
                    onMouseOut={(e)=>e.currentTarget.style.backgroundColor="#f3f4f6"}
                  >

                    <span style={{fontSize:"28px"}}>
                      {action.icon}
                    </span>

                    <span className="fw-bold text-dark text-center">
                      {action.label}
                    </span>

                  </div>

                </div>
              ))}

            </div>

          </div>

        </div>

      </div>


      <Modal isOpen={reportModal} toggle={()=>setReportModal(false)} centered>

        <ModalHeader toggle={()=>setReportModal(false)}>
          Reports
        </ModalHeader>

        <ModalBody>
          <p className="text-muted">
            Analytics and reporting module coming soon.
          </p>
        </ModalBody>

      </Modal>

    </div>

  );

};

export default Overview;